import { fetchChatRun } from '@/services/chat/runApi'
import { fetchThreadMessages } from '@/services/chat/threadsApi'

function wait(ms, signal) {
  return new Promise((resolve) => {
    let timer = null
    const done = () => {
      clearTimeout(timer)
      signal?.removeEventListener('abort', done)
      resolve()
    }
    timer = setTimeout(done, ms)
    signal?.addEventListener('abort', done, { once: true })
  })
}

function isTerminalFailure(run) {
  return run?.status === 'failed' || run?.status === 'cancelled'
}

export async function recoverPhase1Run({
  tid, runId, signal, onComplete, onFailure, initialDelay = 1000, maxDelay = 30000,
}) {
  let delay = initialDelay
  while (!signal?.aborted) {
    try {
      const run = await fetchChatRun(runId, { signal })
      if (isTerminalFailure(run)) {
        onFailure(run.error || 'The background response could not be completed.')
        return
      }
      if (run?.status === 'completed') {
        const messages = await fetchThreadMessages(tid, { signal })
        const answer = messages.find((message) => message.phase1RunId === runId)
        if (answer) {
          onComplete(answer)
          return
        }
      }
    } catch {
      if (signal?.aborted) return
    }
    await wait(delay, signal)
    delay = Math.min(delay * 2, maxDelay)
  }
}
